module.exports = __webpack_public_path__ + "static/media/triangle2.ea1141e1.svg";